const Colors = {
    Elmt: {
        Black: 0x000000,
        White: 0xFFFFFF,
        MainBlue: 0x5992D1,
        MidBlue: 0x82BCE0,
        lightBlue: 0xA9D3ED,
        TextBlue: 0x2969AF,
        MainOrange: 0xF59356,
        MidOrange: 0xF7BE9A,
        LightOrange: 0xFAD4BB,
        SoLightOrange: 0xFCEADC,
        TextOrange: 0xe45F16,
        GoodB3: 0x7dbd38,
        WrongB3: 0xffbc94,
        GrayTxt: 0x656565,

    },
    Text: {
        Black: "#000000",
        White: "#FFFFFF",
        MainBlue: "#5992D1",
        MidBlue: "#82BCE0",
        lightBlue: "#A9D3ED",
        TextBlue: "#2969AF",
        MainOrange: "#F59356",
        MidOrange: "#F7BE9A",
        LightOrange: "#FAD4BB",
        SoLightOrange: "#FCEADC",
        TextOrange: "#e45F16",
        GoodB3: "#7dbd38",
        WrongB3: "#ffbc94",
        GrayTxt: "#656565",

    }
}

export {
    Colors
}